/**
 * Convert a Wayfinder absolute URL to a same-origin-relative href.
 *
 * Generated route helpers bake in APP_URL, which differs from the host that
 * serves the page during local development (loopback, LAN IP) and behind
 * proxies. Cross-origin Inertia visits and fetch calls trigger CORS
 * preflights that session-based web routes intentionally do not answer, so
 * navigation and posts must stay on the current origin. On the canonical
 * host the relative URL resolves to the identical request.
 *
 * Only pass same-application routes: the origin is always dropped so that
 * server rendering and client hydration produce the identical href.
 */
export function localHref(source: string | { url: string }): string {
    const absolute = typeof source === 'string' ? source : source.url;

    try {
        // Absolute URLs parse without a base on both server and client, so
        // SSR and hydration deterministically produce the same relative href.
        // A dummy base covers already-relative inputs when rendering without
        // a window object.
        const parsed = new URL(
            absolute,
            typeof window === 'undefined'
                ? 'http://localhost'
                : window.location.origin,
        );

        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return absolute;
    }
}

/**
 * Rewrite a Wayfinder form definition to a same-origin-relative action.
 * Extra definition fields are preserved for `v-bind` spreads onto Inertia's
 * `Form` component.
 */
export function localForm<T extends { action: string }>(form: T): T {
    return { ...form, action: localHref(form.action) };
}
